// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1no0G","label":"CategoryService_label__14FCk","location":"CategoryService_location__3FkDz"};